__turbopack_context__.v({
  "shopsSelector": "ShopSelector-module-scss-module__eQ5SKG__shopsSelector",
  "shopsSelector__description": "ShopSelector-module-scss-module__eQ5SKG__shopsSelector__description",
  "shopsSelector__imageWrap": "ShopSelector-module-scss-module__eQ5SKG__shopsSelector__imageWrap",
  "shopsSelector__item": "ShopSelector-module-scss-module__eQ5SKG__shopsSelector__item",
  "shopsSelector__itemInfo": "ShopSelector-module-scss-module__eQ5SKG__shopsSelector__itemInfo",
  "shopsSelector__itemName": "ShopSelector-module-scss-module__eQ5SKG__shopsSelector__itemName",
});
